<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochd"><a id="page_v"></a><span class="bold">Contents</span></h1>
<h2 class="tocf"><a href="#/xhtml/05_Acknow">Acknowledgements</a></h2>
<h2 class="tocf"><a href="#/xhtml/06_Credits">Image Credits</a></h2>
<h2 class="tocf"><a href="#/xhtml/07_Capital">A Capital Question</a></h2>
<h2 class="tocf"><a href="#/xhtml/08_Introduction">Introduction</a></h2>
<h2 class="tocc1"><a href="#/xhtml/09_Chapter1"><span class="tpad">Chapter One</span> The Roots of the Salvation Army</a></h2>
<h2 class="tocc"><span href="#/xhtml/10_Chapter2" title="Link target outside of Sample"><span class="tpad">Chapter Two</span> Early Days</span></h2>
<h2 class="tocc"><span href="#/xhtml/11_Chapter3" title="Link target outside of Sample"><span class="tpad">Chapter Three</span> While Women Weep</span></h2>
<h2 class="tocc"><span href="#/xhtml/12_Chapter4" title="Link target outside of Sample"><span class="tpad">Chapter Four</span> Purgatory before the Grave</span></h2>
<h2 class="tocc"><span href="#/xhtml/13_Chapter5" title="Link target outside of Sample"><span class="tpad">Chapter Five</span> War and Disaster</span></h2>
<h2 class="tocc"><span href="#/xhtml/14_Chapter6" title="Link target outside of Sample"><span class="tpad">Chapter Six</span> An International Organisation</span></h2>
<h2 class="tocc"><span href="#/xhtml/15_Chapter7" title="Link target outside of Sample"><span class="tpad">Chapter Seven</span> The Salvation Army and the Media</span></h2>
<h2 class="tocc"><span href="#/xhtml/16_Chapter8" title="Link target outside of Sample"><span class="tpad">Chapter Eight</span> Unresolved Issues</span></h2>
<h2 class="tocc1"><span href="#/xhtml/17_Appendix1" title="Link target outside of Sample"><span class="tpad">Appendix A</span> Forty years of service: Salvation Army response to major worldwide crises</span></h2>
<h2 class="tocc"><span href="#/xhtml/18_Appendix2" title="Link target outside of Sample"><span class="tpad">Appendix B</span> Where the Salvation Army works today with dates of beginnings</span></h2>
<h2 class="tocf1"><span href="#/xhtml/19_References" title="Link target outside of Sample">References</span></h2>
<h2 class="tocf"><span href="#/xhtml/20_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?7630fe5e